module.exports = __webpack_public_path__ + "img/homt__1f10x5——zh.3fb4d15f.png";